const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

const uploadImageToEndpoint = async (file, endpoint, { maxSizeMb = 2 } = {}) => {
	const allowedTypes = ['image/jpeg', 'image/png', 'image/webp']
	const maxSize = maxSizeMb * 1024 * 1024

	if (!allowedTypes.includes(file.type)) {
		throw new Error('Only JPG, PNG, or WebP images are allowed.')
	}

	if (file.size > maxSize) {
		throw new Error(`Image must be under ${maxSizeMb}MB.`)
	}

	const params = new URLSearchParams({
		fileType: file.type,
		fileSize: file.size.toString(),
	})

	// 🔑 Include JWT token
	const token = localStorage.getItem('token')

	const res = await fetch(`${BASE_URL}${endpoint}?${params}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})

	if (!res.ok) throw new Error('Failed to get upload URL')

	const { uploadUrl, publicUrl } = await res.json()

	await fetch(uploadUrl, {
		method: 'PUT',
		headers: {
			'Content-Type': file.type,
		},
		body: file,
	})

	return publicUrl
}

export const uploadImageToS3 = async (file) =>
	uploadImageToEndpoint(file, '/api/uploads/item-options-url')

export const uploadOrgLogoToS3 = async (file, orgSlug) =>
	uploadImageToEndpoint(
		file,
		`/api/${encodeURIComponent(orgSlug)}/uploads/org-logo-url`,
	)

export const uploadMessagingMediaToS3 = async (file, orgSlug) =>
	uploadImageToEndpoint(
		file,
		`/api/${encodeURIComponent(orgSlug)}/uploads/messaging-media-url`,
		{ maxSizeMb: 1 },
	)
